export default __webpack_public_path__ + "static/media/review.500c9f85.png";